module.exports = {
	"header": "Help Center",
	"account": "Account",
	"categories": "Help categories",
	"category": {
		"return": "Return to help center",
		"account": "Account",
		"auction": "Auction",
		"bidding": "Bidding",
		"payment": "Payment"
	},
	"frequentlyAskedQuestions": "Frequently Asked Questions",
	"searchPlaceholder": "Type your question here...",
	"noArticle": "There are no articles for this help category.",
	"noResults": "Not results are matching your query.",
	"searchResults": "Search results",
	"tryAgain": "Please try again."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/help.json5
// module id = 1933
// module chunks = 6